(function () {
  function init(root) {
    if (root.dataset.cprInit) return;
    root.dataset.cprInit = '1';
    var toggle = root.querySelector('[data-cpr-toggle]');
    var row = root.querySelector('[data-cpr-code-row]');
    var copyBtn = root.querySelector('[data-cpr-copy]');
    var timer;

    toggle.addEventListener('click', function () {
      toggle.hidden = true;
      toggle.setAttribute('aria-expanded', 'true');
      row.hidden = false;
    });

    function done() {
      root.classList.add('is-copied');
      clearTimeout(timer);
      timer = setTimeout(function () { root.classList.remove('is-copied'); }, 2000);
    }

    copyBtn.addEventListener('click', function () {
      var code = copyBtn.dataset.code;
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(done, fallback);
      } else {
        fallback();
      }
      function fallback() {
        var ta = document.createElement('textarea');
        ta.value = code;
        ta.style.position = 'fixed';
        ta.style.opacity = '0';
        document.body.appendChild(ta);
        ta.select();
        try { document.execCommand('copy'); done(); } catch (e) {}
        document.body.removeChild(ta);
      }
    });
  }

  document.querySelectorAll('[data-cpr]').forEach(init);
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-cpr]').forEach(init);
  });
})();
